import API_URL from "@/constant/api.config"
import axios from "axios"

export const SupplierAndLogPartnerSuggetions = async (reqData) => {
  const response = await axios
    .post(API_URL + "/member-suggetions", { search: reqData });
  return response.data ? response.data : [];
}


// export const supplierAndPartnterfilter = async (type, country, company, industry,product,search,searchBy,query) => {
//     const response = await axios
//         .post(API_URL + "/search-partner",{type, country, company, industry,product,search,searchBy,query});
//     return response.data ? response.data : [];
// }

export const supplierAndPartnterfilter = async (params) => {
  const response = await axios.post(API_URL + "/search-partner", params);
  return response.data || [];
};

export const getMPSuppliers = async (reqObj) => {
  const response = await axios.post(API_URL + "/filter-market-place-suppliers", reqObj);
  return response.data || [];
}